import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useApi, messages as messagesApi } from '../services/api';

// "Message the Owner" button + inline composer/thread for the listing detail
// page. Keeps contact info private — messages stay on-platform.
export default function MessageOwnerBox({ listingId, ownerId }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const { data, loading, refetch } = useApi(open ? `/messages/${listingId}` : null);
  const msgs = data?.messages || [];
  const [text, setText] = useState('');
  const [sending, setSending] = useState(false);

  if (!user) {
    return (
      <Link to="/login" className="btn btn-outline btn-full">
        Log in to message the owner
      </Link>
    );
  }

  if (user.id === ownerId) return null;

  async function send(e) {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await messagesApi.send(listingId, text.trim());
      setText('');
      refetch();
    } finally {
      setSending(false);
    }
  }

  return (
    <div>
      <button type="button" className="btn btn-outline btn-full" onClick={() => setOpen(v => !v)}>
        {open ? 'Hide Messages' : 'Message the Owner'}
      </button>

      {open && (
        <div style={{ marginTop: '0.85rem' }}>
          {loading ? (
            <p style={{ color: 'var(--ink-muted)' }}>Loading…</p>
          ) : msgs.length > 0 && (
            <div style={{ maxHeight: 260, overflowY: 'auto', padding: '0.75rem', background: 'var(--surface-alt)', borderRadius: 'var(--radius-md)', marginBottom: '0.75rem' }}>
              {msgs.map(m => (
                <div key={m.id} style={{ display: 'flex', justifyContent: m.sender_id === user.id ? 'flex-end' : 'flex-start', marginBottom: '0.5rem' }}>
                  <div style={{
                    maxWidth: '80%', padding: '0.5rem 0.75rem', borderRadius: 'var(--radius-sm)', fontSize: 'var(--text-sm)',
                    background: m.sender_id === user.id ? 'var(--brand)' : 'var(--surface)',
                    color: m.sender_id === user.id ? 'var(--surface)' : 'var(--ink)',
                    border: m.sender_id === user.id ? 'none' : '1px solid var(--border)',
                  }}>
                    {m.body}
                  </div>
                </div>
              ))}
            </div>
          )}
          <form onSubmit={send} style={{ display: 'flex', gap: '0.5rem' }}>
            <input value={text} onChange={e => setText(e.target.value)} placeholder="Ask the owner a question…" style={{ flex: 1 }} />
            <button type="submit" className="btn btn-primary btn-sm" disabled={sending || !text.trim()}>
              {sending ? 'Sending…' : 'Send'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
